import React, { useEffect, useState } from 'react';
import { API } from 'aws-amplify';

interface CashModuleSettingsScreenProps {
  location: {
    storeId?: number;
    title?: string;
  };
}

const CashModuleSettingsScreen: React.FC<CashModuleSettingsScreenProps> = ({ location }) => {
  const storeId = location?.storeId;
  const [cashModuleEnabled, setCashModuleEnabled] = useState<boolean | null>(null);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!storeId) return;
    API.get('AE', '/Stores/GetCashModuleConfig', {
      response: true,
      queryStringParameters: { storeId },
    })
      .then((res: any) => setCashModuleEnabled(res.data.CashModuleEnabled))
      .catch(() => setError('Could not load cash payment setting.'));
  }, [storeId]);

  const handleToggle = (checked: boolean) => {
    if (!storeId) return;
    setSaving(true);
    setError(null);
    const previous = cashModuleEnabled;
    setCashModuleEnabled(checked);
    API.put('AE', '/Stores/UpdateCashModuleConfig', {
      body: { StoreId: storeId, CashModuleEnabled: checked },
    })
      .catch(() => {
        setCashModuleEnabled(previous);
        setError('Could not save cash payment setting.');
      })
      .finally(() => setSaving(false));
  };

  if (!storeId) return <div>No store selected.</div>;
  if (cashModuleEnabled === null) return <div>Loading...</div>;

  return (
    <div style={{ padding: 24 }}>
      <h2>Cash payment — {location?.title}</h2>
      <label>
        <input
          type="checkbox"
          checked={cashModuleEnabled}
          disabled={saving}
          onChange={(e) => handleToggle(e.target.checked)}
        />
        {' '}Cash payment enabled for this store
      </label>
      {error && <p style={{ color: 'red' }}>{error}</p>}
    </div>
  );
};

export default CashModuleSettingsScreen;
